import {
  Component,
  HostBinding,
  Input,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  selector: "app-scribe-icon",
  templateUrl: "./scribe-icon.component.html",
  styleUrls: ["./scribe-icon.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ScribeIconComponent {
  @Input() color: string = "#929292"; // default color (celoBrownGrey)

  @HostBinding("style.--icon-color")
  get iconColor() {
    if (this.color === "celoBrownGrey") return "#929292";
    else if (this.color === "celoSecondary") return "#ff1d5e";
    else return this.color;
  }
}
